var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:_vm.cssClass,attrs:{"size":_vm.size,"disabled":_vm.isSuccess},on:{"click":_vm.copyToClipboard}},[_c('b-icon',{attrs:{"icon":_vm.buttonIcon}}),_vm._v("\n  "+_vm._s(_vm.isSuccess ? 'Copied!' : _vm.buttonText)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }